import { render } from "./policyDetails.vue?vue&type=template&id=7cf6df1b"
import script from "./policyDetails.vue?vue&type=script&lang=js"
export * from "./policyDetails.vue?vue&type=script&lang=js"

import "./policyDetails.vue?vue&type=style&index=0&id=7cf6df1b&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__